import { initializeApollo } from 'gql/client'
import { NextWrapper } from 'data-fetching-wrapper'
import BlogDetailTemplate from '@components/templates/BlogDetailTemplate/BlogDetailTemplate'
import { NewsBySlugDocument } from '@gql/graphql'

const BlogDetail = ({ pagina, news, mainContent }) => {
  return <BlogDetailTemplate pagina={pagina} news={news} mainContent={mainContent} />
}

export const getStaticPaths = NextWrapper.getStaticPaths(
  async () => ({
    paths: [],
    fallback: 'blocking',
  }),
  '/idee-verdi/[slug]'
)

export const getStaticProps = NextWrapper.getStaticProps(
  async ({ params: { slug }, preview, previewData, locale }) => {
    const client = initializeApollo(locale)
    const headers = preview && previewData?.headers ? { cookie: previewData.headers } : {}
    const {
      data: { newsBySlug },
    } = await client.query({
      query: NewsBySlugDocument,
      variables: { slug, preview },
      context: {
        headers,
      },
    })

    if (!newsBySlug) {
      return {
        notFound: true,
      }
    }

    return {
      props: {
        pagina: newsBySlug.pagina,
        news: newsBySlug,
        mainContent: newsBySlug?.pagebuilders?.find((x) => x.key === 'news_content') ?? null,
      },
      revalidate: 60 * 20,
    }
  },
  '/idee-verdi/[slug]'
)

export default BlogDetail
